import { render } from "./PlanDetails.vue?vue&type=template&id=19e96ba0&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-19e96ba0"

export default script